import React from "react";
import "./style.css";

export default function Video() {
  return (
    <>
      <video
        width="100%"
        controls
        autoPlay
        muted
        poster="/video_thumbnail.png"
      >
        <source
          src="https://res.cloudinary.com/u5qztegz/video/upload/f_auto,q_auto,w_1280,c_limit/v1785864265/ziho95pvl4qvlxrumvg2.mp4"
          type="video/mp4"
        />
        Your browser does not support the video tag.
      </video>
    </>
  );
}
